import Vue from 'vue';

Vue.component('web-theme', require('../_themes/esenttia/Web.vue').default);